module.exports = __webpack_public_path__ + "media/images/sail-2x-56e03f27638e23842ce34cb393da7ccc.png";